import authActions from '../../secrets-web/src/store/actions/auth'
import actionTypes from '../actionTypes';

const updateUserPm = (userInfo) => {
  return {
    type: actionTypes.SET_USER_PM,
    payload: userInfo,
  };
};

export default {
  ...authActions,
  updateUserPm
}